import { corvertQuery } from '@/modules/UserEventLanding/functions';
import { apiService } from '@/services/APIService';

const PATH = '/user-event-info-requests';

export default {
  getAll(params) {
    return apiService.get(PATH, params);
  },

  get(id, params) {
    return apiService.get(`${PATH}/${id}`, params);
  },

  create(payload) {
    return apiService.post(PATH, payload);
  },

  update(id, payload) {
    return apiService.put(`${PATH}/${id}`, payload);
  },

  delete(id) {
    return apiService.delete(`${PATH}/${id}`);
  },

  deleteAll(payload) {
    return apiService.delete(`${PATH}${corvertQuery(payload)}`, payload);
  },
};
